import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-2 bg-light" }
const _hoisted_2 = { class: "col-md-12 div-table-boletos box-table" }
const _hoisted_3 = { class: "table table-striped table-hover table-sm" }
const _hoisted_4 = { class: "th-fixed" }
const _hoisted_5 = { class: "col-md-12 text-center table-danger" }
const _hoisted_6 = {
  colspan: "15",
  class: "text-center"
}
const _hoisted_7 = { class: "d-inline" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  class: "text-start",
  "data-label": "Banco"
}
const _hoisted_10 = { class: "navbar fixed-bottom navbar-expand-lg navbar-dark bg-dark" }
const _hoisted_11 = { class: "container-fluid" }
const _hoisted_12 = {
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_13 = { class: "d-flex" }
const _hoisted_14 = { class: "navbar-nav" }
const _hoisted_15 = { class: "nav-item" }
const _hoisted_16 = {
  class: "nav-link",
  href: "#"
}
const _hoisted_17 = { class: "nav-item" }
const _hoisted_18 = {
  class: "nav-link",
  href: "#"
}
const _hoisted_19 = { class: "nav-item" }

import { onMounted, reactive,} from "vue";

//servicos
import * as service from "@/services/BoletosService";
import { addDays, fdata, f2dec, fdataUS, fdataUSS, fdataHora, salvarFiltros, carregarFiltros } from "@/utils/funcoes";

//componentes
import Pesquisa from "./Pesquisa.vue";
import MsgBox from "@/components/MsgBox/Index.vue";
import TextBox from "@/components/TextBox/Index.vue";
import Loading from "@/components/Loading/index.vue"

//janelas
import GerarRemessa from "./GerarRemessa.vue"
import ImportarRetorno from "./ImportarRetorno.vue"


interface configColuna {
    coluna: string,
    exibe: boolean
}

interface BoletoDto extends service.Boleto {
    marcado: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ConsultarBanco',
  setup(__props) {


//vue
var controle = reactive({
    filtros :{
        nome: "",
        dataCadIni: undefined,
        dataCadFim: undefined,
        dataVencIni: undefined,
        dataVencFim: undefined,
        nossoNumero: undefined,
        numeroDocumento: undefined,
        status: undefined,
    } as service.ConsultaPeriodoApiFiltros,
    boletos: [] as BoletoDto[],
    boletoId: 0 as number,
    boleto: {} as service.Boleto,
    ordemDirecao: "Desc",
    ordemColuna: "BoletoId",
    totalRegistros: 0,
    marcarTodos: false,
    totais: {
        qtde: 0,
        total: 0,
    },


    janDetalhes: false,

    pesquisando: false,
    loading: false,
    status: "",
    erro: "",

});


onMounted(() => {
    pesquisar();
})

const pesquisar = async () => {

    controle.erro = "";
    controle.pesquisando = true;
    controle.status = "Pesquisando...";
    controle.boletos = [] as BoletoDto[];

    service.consultarBoletosPeriodoApi(controle.filtros)
        .then((r) => {
            console.log("retorno: ", r);
            controle.pesquisando = false;
            controle.status = "";
            // controle.boletos = r.dados as BoletoDto[];
            // controle.totalRegistros = r.totalRegistros;

            // controle.totais.total = 0;

            // controle.boletos.forEach((boleto) => {

            //     controle.totais.qtde++;

            //     controle.totais.total += (boleto.valorDocumento ?? 0);


            //     //marca os boletos que estavam marcados
            //     // var marcado = controle.marcados.find(a => a.boletoId == boleto.boletoId);
            //     // if (marcado != undefined && marcado != null) {
            //     //     console.log("marcado: ", marcado);
            //     //     boleto.marcado = true;
            //     // }
            // });

        })
        .catch((erro: string) => {
            controle.pesquisando = false;
            controle.erro = erro;
            controle.status = "Erro: " + erro + "<br> Tente novamente mais tarde";
        });
};


const ordenarPor = (coluna: string) => {
    if (controle.ordemColuna == coluna) {
        if (controle.ordemDirecao == "asc")
            controle.ordemDirecao = "desc";
        else
            controle.ordemDirecao = "asc";
    }
    else
        controle.ordemDirecao = "asc";

    controle.ordemColuna = coluna;

    if (controle.ordemDirecao == "asc")
        controle.boletos = controle.boletos.sort((a, b) => (a[coluna] > b[coluna]) ? 1 : ((b[coluna] > a[coluna]) ? -1 : 0));
    else
        controle.boletos = controle.boletos.sort((a, b) => (a[coluna] < b[coluna]) ? 1 : ((b[coluna] < a[coluna]) ? -1 : 0));
}


function marcarTodos() {
    
    controle.boletos.forEach(item => {
        item.marcado = controle.marcarTodos;
    });

}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Loading, {
      isLoading: _unref(controle).loading,
      mensagem: _unref(controle).status
    }, null, 8, ["isLoading", "mensagem"]),
    _createElementVNode("div", _hoisted_1, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "row" }, [
        _createElementVNode("div", { class: "col-md-12 col-12 fs-6 fw-bold" }, " Consulta de Boletos no Banco ")
      ], -1)),
      _createVNode(Pesquisa, { onOnPesquisar: pesquisar }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("table", _hoisted_3, [
          _createElementVNode("thead", _hoisted_4, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", {
                class: "text-start",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (ordenarPor('dataPedido')))
              }, "Banco"),
              _cache[2] || (_cache[2] = _createElementVNode("th", { class: "text-center" }, "Opções", -1))
            ])
          ]),
          _createElementVNode("tbody", null, [
            _withDirectives(_createElementVNode("tr", null, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("td", {
                colspan: "15",
                class: "text-center"
              }, [
                _createElementVNode("div", { class: "d-inline" }, [
                  _createElementVNode("i", { class: "fa fa-cog fa-spin" }),
                  _createTextVNode(" Pesquisando... ")
                ])
              ], -1)
            ]))], 512), [
              [_vShow, _unref(controle).pesquisando == true]
            ]),
            _withDirectives(_createElementVNode("tr", _hoisted_5, [
              _createElementVNode("td", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fa fa-exclamation" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_unref(controle).erro), 1)
                ]),
                _createElementVNode("a", {
                  class: "btn btn-primary btn-sm",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (pesquisar()))
                }, "Repetir")
              ])
            ], 512), [
              [_vShow, _unref(controle).erro != '']
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).boletos, (item, idx) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: idx,
                class: _normalizeClass(item.marcado == true ? 'table-active' : ''),
                onClick: ($event: any) => {_unref(controle).boletoId = item.boletoId; _unref(controle).boleto = item}
              }, [
                _createElementVNode("td", _hoisted_9, _toDisplayString(item.banco), 1)
              ], 10, _hoisted_8))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("nav", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _cache[7] || (_cache[7] = _createElementVNode("ul", { class: "navbar-nav me-auto mb-2 mb-lg-0" }, null, -1)),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("ul", _hoisted_14, [
              _createElementVNode("li", _hoisted_15, [
                _createElementVNode("a", _hoisted_16, "Boletos: [" + _toDisplayString(_unref(controle).boletos?.length) + "] - R$ " + _toDisplayString(_unref(f2dec)(_unref(controle).totais?.total)), 1)
              ]),
              _createElementVNode("li", _hoisted_17, [
                _createElementVNode("a", _hoisted_18, "Selecionado: [" + _toDisplayString(_unref(controle).boletos.filter(a=> a.marcado == true).length) + "] - R$ " + _toDisplayString(_unref(f2dec)(_unref(controle).boletos.filter(a=> a.marcado == true).reduce((total, boleto) => total + (boleto.valorDocumento ?? 0), 0))), 1)
              ]),
              _createElementVNode("li", _hoisted_19, [
                _createVNode(_component_router_link, {
                  to: "/",
                  class: "nav-link"
                }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createElementVNode("i", { class: "fa fa-close" }, null, -1),
                    _createTextVNode(" Fechar ", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})